<template>
  <div class="suspensionTag">
    <v-contextmenu ref="contextmenus">
      <v-contextmenu-item @click="handelChat">聊天</v-contextmenu-item>
    </v-contextmenu>

    <contextMenuInNet ref="contextMenuInNet" :contextMenu="contextmenuRow" :isTask="false"></contextMenuInNet>
    <!-- 
      @name contextMenu
      @desc 右键菜单
      @param contextMenu table 选中行
    -->
    <contextMenu ref="contextMenu" :contextMenu="contextmenuRow" :isTask="false"></contextMenu>

    <div
      style="height: 45px;line-height: 45px;background-color: rgb(215, 215, 215);color:#000;text-align: center;"
    >
      <span style="font-size: 18px;">{{Type===2?"选中数据":"选中数据"}}</span>
    </div>

    <el-table
      style="width: 100%;height:440px;overflow:auto;"
      ref="singleTable"
      :data="resultList"
      highlight-current-row
      @row-dblclick="rowDetailedClick"
      @current-change="handleCurrentChange"
      @row-contextmenu="rowContextmenu"
    >
      <el-table-column
        v-for="(column, index) in columns"
        :key="index"
        :property="column.value"
        :label="column.text"
        :width="column.width"
        :show-overflow-tooltip="column.overflow?true:false"
      ></el-table-column>
      <el-table-column align="left" width="60">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-close"
            circle
            @click="handleDelete(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px;text-align: center;width: 100%;">
      <!--icon="el-icon-circle-check"
        icon="el-icon-delete"
      icon="el-icon-circle-close-outline"-->
      <el-button
        v-if="Type===2?false:true"
        type="primary"
        size="mini"
        style="margin-right:10px;"
        @click="saveClick"
      >存为模板</el-button>
      <el-button v-if="Type===2" type="primary" size="mini" @click="returnClick">确认返回</el-button>
      <el-button type="info" size="mini" style="margin-left:10px;" @click="emptyClick">清空</el-button>
    </div>
    <createTemplate ref="createTemplate" :body="false" :temType="1"></createTemplate>
  </div>
</template>

<script>
import createTemplate from "./createTemplate.vue";
import { mapState, mapMutations, mapGetters } from "vuex";
import { UpdateTemplate } from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  components: {
    createTemplate,
    contextMenu: () => import("@/views/task/common/contextmenu.vue"),
    contextMenuInNet: () =>
      import("@/views/task/common/contextmenuInNet.vue"),
  },
  data() {
    return {
      nowRow: null,
      contextmenuRow: {},
      currentRow: null,
    };
  },
  created() {
    var a = $(window).height();
    this.listHeight = a - 265;
  },
  props: {
    // userId: String,
    //列配置
    columns: {
      type: Array,
      default: function () {
        return [
          // 列
          {
            text: "任务名称",
            value: "TASKNAME",
            overflow: true,
          },
        ];
      },
    },
    isDetailed: {
      //是否显示详情
      type: Boolean,
      default: true,
    },
    filedID: {
      type: String,
      default: "ID",
    },
    tableHeight: {
      type: Number,
      default: 0,
    },
    Type: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState({
      resultList: (state) => state.resultBase.resultList,
      resultSelection: (state) => state.resultBase.resultSelection,
      isResult: (state) => state.resultBase.isResult,
      tagItem: (state) => state.task.tagItem,
      resultTagItem: (state) => state.task.resultTagItem,
      category: (state) => state.task.category,
    }),
  },
  watch: {
    listHeight(val) {
      if (!this.timer) {
        this.listHeight = val;
        this.timer = true;
        const that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },
  methods: {
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    handleCurrentChange(row) {
      //当前行事件
      // console.log('当前：', row);
      this.nowRow = row;
      this.$store.commit("setResultSelection", row);
    },
    detailedClick() {
      //查看详情
      // 				this.$store.commit('changeTaskSource', this.resultList);
      // 				this.$store.commit('changeTotalCount', this.resultList.length);
      if (this.nowRow) {
        this.$emit("detailsEvent", this.resultSelection, function (str) {});
      }
    },
    rowDetailedClick(row) {
      this.$emit("detailsEvent", row);
    },
    deleteClick() {
      //删除当前行
      if (!this.resultSelection) {
        this.$message({
          type: "info",
          message: "请选择需要删除行",
        });
        return;
      }
      this.$store.commit("deleteResult", this.resultSelection.ID);
      if (this.resultList.length == 0) {
        this.$store.state.resultBase.isResult = false;
      }
    },
    emptyClick() {
      this.$emit("deleteResult", this.resultList);
      this.$store.commit("clearResult");
    },
    handleDelete(row) {
      console.log("删除当前行:", row);
      this.$emit("deleteResult", [row]);
      // alert(row[this.filedID])
      this.$store.commit("deleteResultField", {
        id: row[this.filedID],
        filed: this.filedID,
      });
      if (this.resultList.length == 0) {
        this.$store.state.resultBase.isResult = false;
      }
    },
    addClick() {
      //创建结果集模板
      let idArr = [];
      this.resultList.forEach((c) => {
        idArr.push(c[this.filedID]);
      });
      this.$refs.createTemplate.open();
      this.$refs.createTemplate.content = idArr.join(",");
    },
    saveClick() {
      console.log(this.resultList);
      console.log(this.tagItem, "tagItem");
      // return false
      let idArr = [];
      this.resultList.forEach((c) => {
        idArr.push(c[this.filedID]);
      });
      if (this.isResult) {
        this.$confirm("请选择", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "创建新模板", //确定
          cancelButtonText: "保存到原模板", //删除
          type: "warning",
        })
          .then(() => {
            this.$refs.createTemplate.open();
            if (
              this.category == 12 ||
              this.category == 13 ||
              this.category == 16
            ) {
              // 团队类型传入json
              let content = [];
              this.resultList.forEach((res) => {
                content.push({
                  ID: res.SocialId,
                  Type: res.Type,
                });
              });
              this.$refs.createTemplate.content = JSON.stringify(content);
            } else if (this.category == 6) {
              let content = [];
              this.resultList.forEach((res) => {
                content.push({
                  ID: res.ID,
                  Type: res.Type,
                });
              });
              this.$refs.createTemplate.content = JSON.stringify(content);
            } else {
              this.$refs.createTemplate.content = idArr.join(",");
            }
          })
          .catch((action) => {
            if (action === "cancel") {
              let obj = this.resultTagItem;
              console.log("resultTagItem", this.resultTagItem);
              if (this.category == 6) {
                let content = [];
                this.resultList.forEach((res) => {
                  content.push({
                    ID: res.ID,
                    Type: res.Type,
                  });
                });
                obj.CONTENT = JSON.stringify(content);
              } else {
                obj.CONTENT = idArr.join(",");
                console.log(obj, "obj");
              }
              UpdateTemplate(obj, this.category).then((res) => {
                console.log(res);
                if (res == 1) {
                  this.$message({
                    type: "success",
                    message: "保存成功",
                  });
                }
              });
            }
          });
      } else {
        this.$refs.createTemplate.open();
        if (this.category == 12 || this.category == 13 || this.category == 16) {
          // 团队类型传入json
          let content = [];
          this.resultList.forEach((res) => {
            content.push({
              ID: res.SocialId,
              Type: res.Type,
            });
          });
          this.$refs.createTemplate.content = JSON.stringify(content);
        } else if (this.category == 6) {
          let content = [];
          this.resultList.forEach((res) => {
            content.push({
              ID: res.ID,
              Type: res.Type,
            });
          });
          this.$refs.createTemplate.content = JSON.stringify(content);
        } else {
          this.$refs.createTemplate.content = idArr.join(",");
        }
      }
    },
    //确认返回
    returnClick() {
      parent.getValue(this.resultList);
      // this.$emit('getValue',this.resultList);
    },
    rowContextmenu(row, column, event) {
      console.log(row);
      event.preventDefault();
      this.contextmenuRow = row;
      const postition = {
        top: event.clientY,
        left: event.clientX,
      };
      if (row.ObjectType) {
        //运维对象

        this.$refs.contextMenuInNet.Show(postition);
      } else if (row.Name) {
        //聊天
        this.$refs.contextmenus.show(postition);
        return false;
      } else if (row.INSTANCE) {
        ////任务
        this.$refs.contextMenu.Show(postition);
      }
    },

    handelChat() {
      if (!this.contextmenuRow.ID) return;
      if (!this.contextmenuRow.ID === cookieUser.userId) {
        this.$message.warning("不能与自己聊天");
        return;
      }
      let url = `RedCoral://IM/?usercode=${cookieUser.account}&users=${this.contextmenuRow.ID}&chatType=0`;
      window.protocolCheck(url, () => {
        this.$message.warning("协议未注册");
      });
    },
  },
};
</script>

<style lang="less">
.suspensionTag {
  background: white;
  position: relative;
  min-height: 100%;
  .el-button + .el-button {
    margin-left: 0px;
  }
}
</style>
<style scoped>
.suspensionTag >>> .el-table__header-wrapper {
  display: none;
}
</style>
